module.exports = __webpack_public_path__ + "img/DigitalPromotion.c54a41ad.svg";